<div class='RequestHelpButton'>
  <app-button
    [Click]='requestHelpButton.onClick'
    [color]='requestHelpButton.color'
    [disabled]='disabled'
    [size]='requestHelpButton.size'
    [text]='requestHelpButton.text'
    [observeApi]="true"
    class='RequestHelpButton-button'></app-button>
  <app-info-tip-button [type]="'request_help'"></app-info-tip-button>
</div>
